import React from "react";

function Vencimiento90 () {
  const datos = [
    {
      ensayo: '6901',
      serie_epp: 'PR-1234',
      fecha_vencimiento: '30/06/2022',
      cliente_sucursal: 'Iquique',
      dias_x_vencer: '20'
    },
    {
      ensayo: '6902',
      serie_epp: 'PR-1235',
      fecha_vencimiento: '30/06/2022',
      cliente_sucursal: 'Iquique',
      dias_x_vencer: '20'
    },
    {
      ensayo: '6905',
      serie_epp: 'PR-1238',
      fecha_vencimiento: '30/06/2022',
      cliente_sucursal: 'Coquimbo',
      dias_x_vencer: '20'
    },
    {
      ensayo: '6934',
      serie_epp: 'PR-1278',
      fecha_vencimiento: '30/06/2022',
      cliente_sucursal: 'Parral',
      dias_x_vencer: '20'
    },
    {
      ensayo: '6967',
      serie_epp: 'PR-1266',
      fecha_vencimiento: '30/06/2022',
      cliente_sucursal: 'Osorno',
      dias_x_vencer: '20'
    },
  ];

  const columnas = [
    {
      Header: 'ensayo',
      accessor: 'ensayo'
    }, {
      Header: 'serie_epp',
      accessor: 'serie_epp'
    }, {
      Header: 'fecha_vencimiento',
      accessor: 'fecha_vencimiento'
    }, {
      Header: 'cliente_sucursal',
      accessor: 'cliente_sucursal'
    }, {
      Header: 'dias_x_vencer',
      accessor: 'dias_x_vencer'
    }
  ];

  const titulo="Vencimiento 90 dias";
  const botonAgregar = 0;

  return {
    columnas,
    datos,
    titulo,
    botonAgregar,
  };
};

export default Vencimiento90;